// extracted by mini-css-extract-plugin
export default {"emailsSent":"nav_emailsSent__gQb3z"};